/**
 * PUDO 店舗の詳細ページのルートコンポーネント
 *
 * テンプレートはJinjaの以下と紐づく
 * templates/organizations/{...}/point.html > templates/default/point.html
 */
import { defineComponent } from 'vue'

import PointPage from "@/organizations/_default/point"
import ImageSlider from "@/components/point/ImageSlider.vue"

// 画像スライダーに表示する extra_fields のキー（表示順）
const IMAGE_FIELDS = ['ロッカー近影', 'ロッカー遠影', '館内地図', '予備画像']

export default defineComponent({
  extends: PointPage,
  components: { ImageSlider },
  setup(props, context) {
    // 画像フィールドのうち値があるものだけ抽出し、ImageSlider に渡す配列を構築（ページロード時に一度だけ評価）
    const images = IMAGE_FIELDS
      .filter(field => storelocator.point.point['extra_fields'][field])
      .map(field => ({
        url: storelocator.point.point['extra_fields'][field],
        alt: field,
      }))

    const page = PointPage.setup(props, context)

    return {
      ...page,
      images,
    }
  }
})
